module.exports = new __parcel__URL__("bossfight_hud_go_to_battle_button.720c4bd7.png").toString();